"use client";

import { useEffect, useState, useCallback } from "react";
import { getCategories } from "@/features/categories/services/catalog";
import type { Category } from "@/features/categories/types";

export function useCategoriesList() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getCategories();
      setCategories(result.categories);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const retry = useCallback(() => {
    setError(null);
    fetchCategories();
  }, [fetchCategories]);

  return {
    categories,
    loading,
    error,
    viewMode,
    setViewMode,
    retry,
  };
}
